// extracted by mini-css-extract-plugin
module.exports = {"dialog-scrollbar":"Dialog_dialog-scrollbar__3uYqF"};